/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RefreshTokenResponse {
    getFixupPrototypeFunction() { return RefreshTokenResponse.fixupPrototype; }

    static newInstance(model: Partial<RefreshTokenResponse>): RefreshTokenResponse {
        let obj = Object.assign(new RefreshTokenResponse(), model);
        RefreshTokenResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RefreshTokenResponse>): RefreshTokenResponse {
        if (!model) return null;
        return RefreshTokenResponse.newInstance(<RefreshTokenResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RefreshTokenResponse) {
        if (!obj) return;

        models.RefreshTokenResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RefreshTokenResponse): boolean {
        Object.setPrototypeOf(obj, RefreshTokenResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.refresh_count === undefined) {
            this.refresh_count = 0;
        }
    }

    /**
     * access token obtained from the auth token api
     */
    access_token: string;

    /**
     * Time in UTC at which the token was issued  at
     */
    issued_at: string;

    /**
     * Time in UTC till which the token will be valid till
     */
    expires_at: string;

    /**
     * The count of refresh token used.It can be used for 3 max refresh count after which the token will expired.
     */
    refresh_count: number;

}
